// TODO: Clean up unnecessary attributes after POC test

const homePage = {
    inventoryImpressions: {
        pixallData: {
            // isCarousel: !isHpRedesign,
            label: 'dl_v_lstg',
            listingType: 'elot',
        },
    },
    ownerImpressions: {
        pixallData: {
            // eventSource: 'dealership',
            label: 'dl_c_lstg',
            // listingType: 'elot',
            // listingCode: listing.ownerId,
        },
    },
    ownerLogoClick: {
        par: 'dl_v_lstg',
    },
};

const findDealer = {
    inventoryImpressions: {
        pixallData: {
            listingType: 'elot',
            label: 'dl_v_lstg',
            rank: 1,
        },
    },
    inventoryClick: {
        par: 'elot', // needed for cmp
        // lstg_type: 'v_dl', - not used in handler
    },
    ownerImpressions: {
        pixallData: {
            label: 'dl_c_lstg',
            // listingType: 'elot',
            // eventSource: 'dealership',
            // listingCode: owner.id,
        },
    },
    ownerLogoClick: {
        par: 'dl_v_lstg',
        // listingType: 'v_dl', not used?
        pixallData: {
            isCarousel: true,
            listingType: 'elot',
        },
    }
}

export default {
    'atc_h': homePage,
    'fyd_srl': findDealer,
};
